//项目详情
import { Flex, Steps, Descriptions, Card, Space, Button, Input, Upload, message, Select, Progress, Rate, InputNumber, Tag, Form, DatePicker } from 'antd';
import axios from 'axios';
import { InboxOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import 'antd/dist/reset.css';
import './index.scss'
import { useEffect, useState, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import React from 'react';
import moment from 'moment';
import { getToken } from '@/utils/token';

import { getProjectDetailAPI, updateProjectAPI } from '@/apis/project';
import { downloadFileWithSaveDialog } from '@/apis/file';
// import { uploadFileAPI } from '@/apis/file'; // replaced by manual axios upload with progress
import { getShowLocationListAPI } from '@/apis/showLocation';
import { getAllUsersListAPI } from '@/apis/user';

import { buildUrl, SERVER_CONF } from '@/config/server'


// 旧表单回调已移除

const ProjectDetail = () => {

    // const [execPlace, setExecPlace] = useState(""); // 不再使用单独的 execPlace
    // const [showLocation, setShowLocation] = useState({}) // 场地详情现在仅通过 ID 跳转显示，不再使用完整对象
    const [project, setProject] = useState({})
    const [projectStatus, setProjectStatus] = useState(0) // 0~4, 100 完成, 101 取消
    const [allUsers, setAllUsers] = useState([])
    const [showLocationOptions, setShowLocationOptions] = useState([])
    const [designSelected, setDesignSelected] = useState([])
    const [execSelected, setExecSelected] = useState([])
    const [showLocationId, setShowLocationId] = useState(null)
    const [projectFile, setProjectFile] = useState(null)
    const [danceFileName, setDanceFileName] = useState('')
    const [danceUploadPercent, setDanceUploadPercent] = useState(0)
    const [execMetrics, setExecMetrics] = useState({ nr: 0, d: 0, c: 0, info: '' })
    const [satisfaction, setSatisfaction] = useState({ s: 5, info: '' })

    // 本地缓存文件原始名称(含后缀)，避免刷新后丢失，键: fileId -> name
    const FILE_NAME_CACHE_KEY = 'projectFileNames';
    const storeFileName = (id, name)=>{
        if(!id || !name) return; try {
            const map = JSON.parse(localStorage.getItem(FILE_NAME_CACHE_KEY)||'{}');
            map[id] = name; localStorage.setItem(FILE_NAME_CACHE_KEY, JSON.stringify(map));
        } catch(e){}
    }
    const getStoredFileName = (id)=>{
        try { const map = JSON.parse(localStorage.getItem(FILE_NAME_CACHE_KEY)||'{}'); return map[id]; } catch(e){ return undefined }
    }

    // 上传舞步文件 (完整舞步文件)

    const [searchParams] = useSearchParams()
    const projectId = parseInt(searchParams.get('id'))

    const { t } = useTranslation();
    const [, contextHolder] = message.useMessage();

    const baseItems = [
        { key: '1', label: t('ProjectAdditionFormList.ProjectName'), children: project.projectName },
        { key: '2', label: '负责人', children: project.projectManager },
        { key: '3', label: '无人机数量', children: project.uavNum },
        { key: '4', label: '城市', children: project.city },
        { key: '5', label: '开始时间', children: project.projectStartTime },
        { key: '6', label: '结束时间', children: project.projectEndTime },
        { key: '7', label: '说明', children: project.projectInfo }
    ]
    // 绑定后的场地与人员展示（进入状态2及以后仍需可见）
    const userIdToName = (id)=> {
        const u = allUsers.find(u=> String(u.id)===String(id) || String(u.userId)===String(id))
        return u ? (u.userName || u.username || u.name || u.id) : id
    }
    const designNames = designSelected.map(userIdToName).join(', ')
    const execNames = execSelected.map(userIdToName).join(', ')
    const locationItems = [
        { key: '1', label: '场地ID', children: showLocationId ? (<a href={`/ShowLocationDetail?id=${showLocationId}`} target='_blank' rel='noreferrer'>{showLocationId}</a>) : '未绑定场地' },
        { key: '2', label: '设计人员', children: designSelected.length? designNames : '未选择' },
        { key: '3', label: '执行人员', children: execSelected.length? execNames : '未选择' }
    ]

    // 自定义上传方法
    const danceUploadProps = {
        name: 'file',
        multiple: false,
        showUploadList: false,
    disabled: !!projectFile && projectStatus !== 2,
        customRequest: async ({ file, onSuccess, onError, onProgress }) => {
            try {
                setDanceFileName(file.name)
                setDanceUploadPercent(0)
                const fd = new FormData(); fd.append('file', file)
                const tokenObj = getToken() ? JSON.parse(getToken()) : null
                const token = tokenObj ? tokenObj.token : ''
                const res = await axios.post(buildUrl(SERVER_CONF.FILE_UPLOAD), fd, {
                    headers: { 'Content-Type':'multipart/form-data', ...(token? { token }: {}) },
                    onUploadProgress: (e)=> {
                        if (!e.total) return
                        const percent = Math.round(e.loaded / e.total * 100)
                        setDanceUploadPercent(percent)
                        if (onProgress) onProgress({ percent })
                    }
                })
                if (res.data.code === 0) {
                    setProjectFile(res.data.data)
                    storeFileName(res.data.data, file.name)
                    message.success('上传成功')
                    onSuccess(res.data.data)
                } else throw new Error('上传失败')
            } catch(e){
                setDanceUploadPercent(0)
                message.error('上传失败')
                onError(e)
            }
        }
    }

    const resetDanceUpload = ()=> {
        if (projectStatus !==2) return
    setProjectFile(null)
        setDanceFileName('')
        setDanceUploadPercent(0)
    }

    //设置飞行视频组件,视频地址不存在则显示上传按钮。存在则显示视频组件
    // 加载初始数据

    // 移除未使用的旧模态框控制函数

    //获取项目信息实例
    useEffect(() => {
        async function init(){
            const res = await getProjectDetailAPI(projectId)
            setProject(res.data)
            setProjectStatus(res.data.projectStatus)
            if (res.data.projectDesign) setDesignSelected(res.data.projectDesign.split(',').filter(Boolean))
            if (res.data.projectExec) setExecSelected(res.data.projectExec.split(',').filter(Boolean))
            if (res.data.showLocationId) setShowLocationId(res.data.showLocationId)
            if (res.data.projectFile) {
                setProjectFile(res.data.projectFile)
                // 尝试恢复原始文件名
                const cachedName = getStoredFileName(res.data.projectFile)
                if (cachedName) setDanceFileName(cachedName)
            }
            if (res.data.uavExecData) try { setExecMetrics(JSON.parse(res.data.uavExecData)) } catch(e){}
            if (res.data.projectExecData) try { setSatisfaction(JSON.parse(res.data.projectExecData)) } catch(e){}
        }
        init()
    }, [projectId])

    // 加载用户与场地列表（仅在需要编辑时）
    useEffect(() => {
        if (projectStatus === 0 || projectStatus === 1) {
            getAllUsersListAPI().then(res => setAllUsers(res.data || [])).catch(()=>{})
            getShowLocationListAPI().then(res => {
                const opts = (res.data || []).map(it => ({ label: it.placeName, value: it.id }))
                setShowLocationOptions(opts)
            }).catch(()=>{})
        }
    }, [projectStatus])

    // useEffect(() => {
    //   console.log('项目状态', project);

    // }, [project])

    // 场地对象详情不再单独缓存，直接通过 ID 链接跳转；若后续需要可恢复此逻辑
    // useEffect(() => { ... })

    //处理确认按钮更新进度条
        // 下一步提交逻辑
    const [form] = Form.useForm();

    const saveBaseDraft = async () => {
        try {
            const vals = await form.validateFields();
            const payload = {
                id: projectId,
                projectName: vals.projectName,
                projectManager: vals.projectManager,
                uavNum: vals.uavNum,
                city: vals.city,
                projectInfo: vals.projectInfo || '',
                // 使用 ISO LocalDateTime 格式（含'T'）以适配后端 java.time.LocalDateTime 解析
                projectStartTime: vals.range && vals.range[0] ? vals.range[0].format('YYYY-MM-DDTHH:mm:ss.SSS') : project.projectStartTime,
                projectEndTime: vals.range && vals.range[1] ? vals.range[1].format('YYYY-MM-DDTHH:mm:ss.SSS') : project.projectEndTime,
                showLocationId: showLocationId || undefined,
                projectDesign: designSelected.join(',')+',',
                projectExec: execSelected.join(',')+','
            }
            await updateProjectAPI(payload)
            message.success('已保存草稿')
            // 刷新展示
            setProject(p => ({ ...p, ...payload }))
        } catch(e) {
            // 校验未通过不提示错误信息（antd 已显示）
        }
    }

    const goNext = async () => {
        try {
            if (projectStatus === 0) {
                const vals = await form.validateFields();
                if (!showLocationId) { message.warning('请选择场地'); return }
                if (!designSelected.length) { message.warning('请选择设计人员'); return }
                if (!execSelected.length) { message.warning('请选择执行人员'); return }
                const payload = {
                    id: projectId,
                    projectStatus: 1,
                    projectName: vals.projectName,
                    projectManager: vals.projectManager,
                    uavNum: vals.uavNum,
                    city: vals.city,
                    projectInfo: vals.projectInfo || '',
                    projectStartTime: vals.range && vals.range[0] ? vals.range[0].format('YYYY-MM-DDTHH:mm:ss.SSS') : project.projectStartTime,
                    projectEndTime: vals.range && vals.range[1] ? vals.range[1].format('YYYY-MM-DDTHH:mm:ss.SSS') : project.projectEndTime,
                    showLocationId: showLocationId,
                    projectDesign: designSelected.join(',')+',',
                    projectExec: execSelected.join(',')+','
                }
                await updateProjectAPI(payload)
                setProject(p => ({ ...p, ...payload }))
                setProjectStatus(1)
            } else if (projectStatus === 1) {
                if (!showLocationId) { message.warning('请选择场地'); return }
                if (!designSelected.length) { message.warning('请选择设计人员'); return }
                if (!execSelected.length) { message.warning('请选择执行人员'); return }
                await updateProjectAPI({
                    id: projectId,
                    projectStatus: 2,
                    showLocationId: showLocationId,
                    projectDesign: designSelected.join(',')+',',
                    projectExec: execSelected.join(',')+','
                })
                setProjectStatus(2)
            } else if (projectStatus === 2) {
                if (!projectFile) { message.warning('请先上传完整舞步文件'); return }
                await updateProjectAPI({ id: projectId, projectStatus: 3, projectFile })
                setProjectStatus(3)
            } else if (projectStatus === 3) {
                await updateProjectAPI({ id: projectId, projectStatus: 4, uavExecData: JSON.stringify(execMetrics) })
                setProjectStatus(4)
            } else if (projectStatus === 4) {
                await updateProjectAPI({ id: projectId, projectExecData: JSON.stringify(satisfaction) })
                message.success('项目已完成')
                setProjectStatus(100)
            }
        } catch(e){
            message.error('操作失败')
        }
    }

    const canProceed = (()=>{
        if (projectStatus===0) return true // 校验在点击时做，允许按钮可点
        if (projectStatus===1) return showLocationId && designSelected.length && execSelected.length
    if (projectStatus===2) return !!projectFile
        if (projectStatus===3) return true
        if (projectStatus===4) return true
        return false
    })()

    const initialRange = useMemo(()=>{
        return (project.projectStartTime && project.projectEndTime) ? [moment(project.projectStartTime), moment(project.projectEndTime)] : []
    }, [project.projectStartTime, project.projectEndTime])

    // 动态填充基础表单（初建阶段）
    useEffect(()=>{
        if (projectStatus === 0 && project && form) {
            form.setFieldsValue({
                projectName: project.projectName,
                projectManager: project.projectManager,
                uavNum: project.uavNum,
                city: project.city,
                projectInfo: project.projectInfo,
                range: initialRange
            })
        }
    }, [project, projectStatus, form, initialRange])

    return (
        <div className='project-detail-container'>
                        <Card style={{ marginBottom: 24, borderRadius: 12 }}>
                            <Space direction='vertical' style={{ width: '100%' }}>
                                <Steps size='small' current={projectStatus >=100?5:projectStatus} items={[
                                    { title: '初建' },
                                    { title: '项目确定' },
                                    { title: '执飞前' },
                                    { title: '执飞中' },
                                    { title: '客户确认' }
                                ]} />
                                <Progress percent={ projectStatus>=100?100: Math.round(( (projectStatus)/4)*100) } status={projectStatus===101?'exception':'active'} />
                            </Space>
                        </Card>

            <Flex className='cards-flex' gap={16} wrap="wrap" justify="flex-start">

                                {/* 项目基础数据 (置顶) */}
                                <Card title='项目基础数据' className='card-modern' style={{ width: 1000, maxWidth:'100%' }}>
                                    {projectStatus === 0 ? (
                                        <Form
                                            form={form}
                                            layout='vertical'
                                            initialValues={{
                                                projectName: project.projectName,
                                                projectManager: project.projectManager,
                                                uavNum: project.uavNum,
                                                city: project.city,
                                                projectInfo: project.projectInfo,
                                                range: initialRange
                                            }}
                                            className='base-form'
                                        >
                                            <Form.Item name='projectName' label='项目名称' rules={[{ required:true,message:'请输入项目名称' }]}>
                                                <Input placeholder='输入项目名称' />
                                            </Form.Item>
                                            <Form.Item name='projectManager' label='负责人' rules={[{ required:true,message:'请输入负责人' }]}>
                                                <Input placeholder='输入负责人' />
                                            </Form.Item>
                                            <Form.Item name='uavNum' label='无人机数量' rules={[{ required:true,message:'请输入数量' }]}>
                                                <InputNumber min={1} style={{ width:'100%' }} />
                                            </Form.Item>
                                            <Form.Item name='city' label='城市' rules={[{ required:true,message:'请输入城市' }]}>
                                                <Input placeholder='输入城市' />
                                            </Form.Item>
                                            <Form.Item name='range' label='时间范围' rules={[{ required:true,message:'请选择时间范围' }]}>
                                                <DatePicker.RangePicker showTime style={{ width:'100%' }} />
                                            </Form.Item>
                                            <Form.Item name='projectInfo' label='说明'>
                                                <Input.TextArea rows={3} placeholder='可填写补充说明' />
                                            </Form.Item>
                                            <div style={{ gridColumn:'1 / -1' }}>
                                                <Space>
                                                    <Button onClick={saveBaseDraft}>保存草稿</Button>
                                                </Space>
                                            </div>
                                        </Form>
                                    ) : (
                                        <Descriptions column={2} size='small' items={baseItems} />
                                    )}
                                </Card>

                                {/* 场地与人员 (状态1 可编辑) */}
                                <Card title='场地与成员' className='card-modern' style={{ width: 500 }}>
                                    {(projectStatus ===0 || projectStatus ===1) ? (
                                        <Space direction='vertical' style={{ width:'100%' }}>
                                            <Select
                                                style={{ width: '80%' }}
                                                placeholder='选择场地'
                                                value={showLocationId}
                                                onChange={v=> setShowLocationId(v)}
                                                options={showLocationOptions}
                                                allowClear
                                            />
                                            <Select
                                                style={{ width: '80%' }}
                                                mode='multiple'
                                                placeholder='选择设计人员'
                                                value={designSelected}
                                                onChange={setDesignSelected}
                                                options={allUsers.map(u=>({ label: u.userName || u.username || u.name || u.id, value: String(u.id) }))}
                                                allowClear
                                            />
                                            <Select
                                                style={{ width: '80%' }}
                                                mode='multiple'
                                                placeholder='选择执行人员'
                                                value={execSelected}
                                                onChange={setExecSelected}
                                                options={allUsers.map(u=>({ label: u.userName || u.username || u.name || u.id, value: String(u.id) }))}
                                                allowClear
                                            />
                                            <Space wrap>
                                                <Tag color={showLocationId? 'green':'default'}>{showLocationId? `场地ID:${showLocationId}`:'未选择场地'}</Tag>
                                                <Tag color={designSelected.length? 'green':'default'}>设计:{designSelected.length}</Tag>
                                                <Tag color={execSelected.length? 'green':'default'}>执行:{execSelected.length}</Tag>
                                            </Space>
                                        </Space>
                                    ) : (
                                        <Descriptions column={1} size='small' items={locationItems} />
                                    )}
                                </Card>

                                {/* 舞步文件上传 (状态2 可上传) */}
                                <Card title='完整舞步文件' className='card-modern upload-card' style={{ width: 500 }}>
                                    {projectStatus ===2 ? (
                                        <div className='upload-panel'>
                                            {!projectFile && (
                                                <Upload.Dragger {...danceUploadProps} style={{ padding:16 }}>
                                                    <p className='ant-upload-drag-icon'><InboxOutlined /></p>
                                                    <p>{danceFileName || '点击或拖拽上传文件'}</p>
                                                    {danceUploadPercent > 0 && danceUploadPercent < 100 && (
                                                        <Progress percent={danceUploadPercent} size='small' className='upload-progress' />
                                                    )}
                                                </Upload.Dragger>
                                            )}
                                            {projectFile && (
                                                <Space direction='vertical'>
                                                    <Tag color='green'>已上传 (ID:{projectFile})</Tag>
                                                    {danceFileName && <span className='file-name'>文件: {danceFileName}</span>}
                                                    <Space>
                                                        <Button size='small' onClick={()=> downloadFileWithSaveDialog(projectFile, danceFileName || undefined)}>下载</Button>
                                                        <Button size='small' onClick={resetDanceUpload}>重新上传</Button>
                                                    </Space>
                                                </Space>
                                            )}
                                        </div>
                                    ) : (
                                        projectFile ? (
                                            <Space direction='vertical'>
                                                <Space>
                                                    <Tag color='green'>文件ID: {projectFile}</Tag>
                                                    <Button size='small' onClick={()=> downloadFileWithSaveDialog(projectFile, danceFileName || undefined)}>下载</Button>
                                                </Space>
                                                {danceFileName && <span className='file-name'>文件: {danceFileName}</span>}
                                            </Space>
                                        ) : <Tag>未上传</Tag>
                                    )}
                                </Card>

                                {/* 执飞中数据填写 (状态3) */}
                                {(projectStatus ===3 || projectStatus===100) && (
                                    <Card title='执行数据记录' className='card-modern' style={{ width: 500 }}>
                                        {projectStatus===3 ? (
                                            <Space direction='vertical' style={{ width:'100%' }}>
                                                <InputNumber addonBefore='未起飞' min={0} value={execMetrics.nr} onChange={v=> setExecMetrics(m=>({...m,nr:v||0}))} style={{ width:'100%' }} />
                                                <InputNumber addonBefore='掉落' min={0} value={execMetrics.d} onChange={v=> setExecMetrics(m=>({...m,d:v||0}))} style={{ width:'100%' }} />
                                                <InputNumber addonBefore='降落不准' min={0} value={execMetrics.c} onChange={v=> setExecMetrics(m=>({...m,c:v||0}))} style={{ width:'100%' }} />
                                                <Input.TextArea placeholder='备注' value={execMetrics.info} onChange={e=> setExecMetrics(m=>({...m,info:e.target.value}))} rows={3} />
                                            </Space>
                                        ) : (
                                            <Descriptions column={1} size='small' items={[
                                                { key:'nr', label:'未起飞', children: execMetrics.nr },
                                                { key:'d', label:'掉落', children: execMetrics.d },
                                                { key:'c', label:'降落不准', children: execMetrics.c },
                                                { key:'info', label:'备注', children: execMetrics.info || '-' }
                                            ]} />
                                        )}
                                    </Card>
                                )}
                                {/* 客户满意度 (状态4) */}
                                {(projectStatus ===4 || projectStatus===100) && (
                                    <Card title='客户满意度' className='card-modern' style={{ width: 500 }}>
                                        {projectStatus===4 ? (
                                            <Space direction='vertical' style={{ width:'100%' }}>
                                                <Rate value={satisfaction.s} onChange={v=> setSatisfaction(s=>({...s,s:v}))} />
                                                <Input.TextArea placeholder='备注' value={satisfaction.info} onChange={e=> setSatisfaction(s=>({...s,info:e.target.value}))} rows={3} />
                                            </Space>
                                        ) : (
                                            <Descriptions column={1} size='small' items={[
                                                { key:'s', label:'满意度', children: <Rate disabled value={satisfaction.s} /> },
                                                { key:'info', label:'备注', children: satisfaction.info || '-' }
                                            ]} />
                                        )}
                                    </Card>
                                )}

            </Flex>

            {/* 效果图展示区域 */}
            {/* {projectStatus === 3 && (
                <Card
                    style={{
                        marginTop: '24px',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        textAlign: 'center'
                    }}
                >
                    <div style={{
                        marginBottom: '24px',
                        fontSize: '18px',
                        fontWeight: '600',
                        color: '#333'
                    }}>效果图展示
                    </div>
                    <Flex gap="24" justify="center" wrap="wrap">
                        <div style={{
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}>
                            <Image
                                width={280}
                                height={200}
                                src='https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png'
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                        <div style={{
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}>
                            <Image
                                width={280}
                                height={200}
                                src='https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png'
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                        <div style={{
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}>
                            <Image
                                width={280}
                                height={200}
                                src='https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png'
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                    </Flex>
                </Card>
            )} */}

            {/* 旧模态框已移除 */}

            {/* 现场效果图
            {projectStatus === 1 && (
                <div>
                    <div style={{
                        marginBottom: '16px',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#333'
                    }}>
                        现场效果图
                    </div>
                    <Image
                        width={200}
                        height={200}
                        src="error"
                        fallback="data:image/png;base64,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"
                    />
                </div>
            )} */}

                        {/* 操作按钮 */}
                        {projectStatus !== 100 && projectStatus !== 101 && (
                            <div style={{ textAlign:'center', marginTop:32 }}>
                                <Space size='large'>
                                    {projectStatus===0 && <Button onClick={saveBaseDraft}>保存草稿</Button>}
                                    <Button type='primary' size='large' disabled={!canProceed} onClick={goNext}>
                                        {projectStatus===4? '完成项目' : '下一步'}
                                    </Button>
                                </Space>
                            </div>
                        )}

            {contextHolder}
        </div>
    )
}

export default ProjectDetail